<p-button class="about-btn legend-act" [rounded]="true" [text]="true" [raised]="true" (onClick)="openDialog()"> {{ 'MAP.ABOUT.BTN' | translate }}</p-button>

<p-dialog header="{{ 'MAP.ABOUT.TITLE' | translate }}" [(visible)]="displayAboutDialog" [modal]="true" [closable]="true" [style]="{ width: '70%' }" (onHide)="hideDialog()">
    <div class="content-about">
        {{ 'MAP.ABOUT.CONTENT' | translate }}
        <br>
        <br>
        {{ 'MAP.ABOUT.CONTENT2' | translate }}
        <br>
        <br>
        <div [innerHTML]="translatedContent"></div> <!--Différent à cause de la résolution de liens-->
        <br>
        <br>
        {{ 'MAP.ABOUT.CONTENT4' | translate }}
    </div>
</p-dialog>